import React from 'react';
import { MenuItem, Pagination, Select } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface TradeHistoryPaginationProps {
  page: number;
  pageSize: number;
  totalPages: number;
  totalElements: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
}

const TradeHistoryPagination: React.FC<TradeHistoryPaginationProps> = ({
                                                                         page,
                                                                         pageSize,
                                                                         totalPages,
                                                                         totalElements,
                                                                         onPageChange,
                                                                         onPageSizeChange
                                                                       }) => {
  const { t } = useTranslation();

  return (
      <div className="flex flex-col md:flex-row justify-between items-center gap-4 pt-4 bg-gray-50/90 dark:bg-neutral-900/40 p-3 rounded-xl shrink-0">
        <div className="flex items-center gap-3">
        <span className="text-[10px] text-gray-400 uppercase font-black tracking-widest">
          {t('history.pagination.show')}
        </span>
          <Select
              value={pageSize}
              onChange={(e) => onPageSizeChange(Number(e.target.value))}
              size="small"
              className="bg-white dark:bg-neutral-800/50 text-gray-700 dark:text-gray-300 !text-xs rounded-lg shadow-sm"
              sx={{ height: '36px', '.MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(0,0,0,0.05)' } }}
          >
            {[100, 250, 500, 1000].map((size) => (
                <MenuItem key={size} value={size} className="!text-xs">{size}</MenuItem>
            ))}
          </Select>
        </div>

        <Pagination
            count={totalPages}
            page={page}
            onChange={(_, p: number) => onPageChange(p)}
            size="medium"
            shape="rounded"
            sx={{
              '& .MuiPaginationItem-root': { color: '#94a3b8', fontWeight: 'bold' },
              '& .Mui-selected': { backgroundColor: '#3f51b5 !important', color: 'white !important', borderRadius: '8px' },
            }}
        />

        <div className="text-[10px] text-gray-400 font-black font-mono bg-white dark:bg-neutral-900/50 px-3 py-1.5 rounded-lg border border-gray-100 dark:border-white/5">
          {totalElements} {t('history.pagination.items_total')}
        </div>
      </div>
  );
};

export default TradeHistoryPagination;